// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Live Casino lobby – header animations and category rows */

.live-casino-page {
  background: #142326;
  min-height: 100%;
  width: 100%;
}

.live-casino-header {
  position: relative;
  width: 100%;
  overflow: hidden;
  border-radius: 8px;
}

.live-casino-header__img {
  width: 100%;
  display: block;
  min-height: 180px;
  object-fit: cover;
}

.live-casino-header__text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  text-align: center;
  width: 90%;
  pointer-events: none;
}

.live-casino-header__text-name {
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 45px;
  line-height: 54px;
  letter-spacing: 0.09em;
  color: #fff;
  text-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  text-transform: uppercase;
}

.live-casino-header__text-credo {
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 26px;
  line-height: 34px;
  letter-spacing: 0.09em;
  color: #fff;
  margin-top: 10px;
  text-align: center;
}

.live-casino-lamp {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 37vh;
  min-height: 160px;
  width: 100%;
  z-index: 0;
}

.live-casino-lava {
  filter: url('#goo');
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
}

.live-casino-blob {
  border-radius: 50%;
  background: linear-gradient(90deg, #eeaeca 0%, #d99cce 10%, #de86e9 24%, #c996e9 47%, #a5aee9 68%, #94bbe9 100%);
  position: absolute;
}

.live-casino-blob:nth-child(2) { width: 200px; height: 200px; left: 0; bottom: -15%; animation: lc-wobble 4s ease-in-out alternate infinite, lc-blob-one 28s infinite; }
.live-casino-blob:nth-child(3) { width: 330px; height: 330px; right: 5%; bottom: -65%; animation: lc-wobble 5s ease-in-out alternate infinite, lc-blob-two 22s infinite; }
.live-casino-blob:nth-child(4) { width: 150px; height: 150px; bottom: -15%; left: 5%; animation: lc-wobble 6s ease-in-out alternate infinite, lc-blob-three 33s infinite; }
.live-casino-blob:nth-child(5) { width: 125px; height: 125px; bottom: 0; left: 0; animation: lc-wobble 8s ease-in-out alternate infinite, lc-blob-five 18s infinite; }
.live-casino-blob:nth-child(6) { width: 55px; height: 55px; bottom: -25%; left: 17%; animation: lc-wobble 9s ease-in-out alternate infinite, lc-blob-five 32s infinite; }
.live-casino-blob:nth-child(7) { width: 35px; height: 35px; bottom: -25%; right: 20%; animation: lc-wobble 10s ease-in-out alternate infinite, lc-blob-six 12s infinite; }
.live-casino-blob:nth-child(8) { width: 85px; height: 85px; bottom: -35%; right: 22%; animation: lc-wobble 11s ease-in-out alternate infinite, lc-blob-seven 32s infinite; }
.live-casino-blob:nth-child(9) { width: 11px; height: 11px; bottom: -15%; right: 35%; animation: lc-wobble 11s ease-in-out alternate infinite, lc-blob-one 32s infinite; }
.live-casino-blob:nth-child(10) { width: 48px; height: 48px; bottom: -5%; right: 26%; animation: lc-wobble 12s ease-in-out alternate infinite, lc-blob-one 22s infinite; }
.live-casino-blob:nth-child(11) { width: 22px; height: 22px; bottom: -5%; right: 76%; animation: lc-wobble 13s ease-in-out alternate infinite, lc-blob-four 36s infinite; }
.live-casino-blob:nth-child(12) { width: 72px; height: 72px; bottom: -5%; right: 50%; animation: lc-wobble 14s ease-in-out alternate infinite, lc-blob-six 20s infinite; }
.live-casino-blob:nth-child(13) { width: 89px; height: 89px; bottom: -12%; right: 40%; animation: lc-wobble 15s ease-in-out alternate infinite, lc-blob-five 30s infinite; }
.live-casino-blob:nth-child(14) { width: 92px; height: 92px; bottom: -5%; right: 56%; animation: lc-wobble 16s ease-in-out alternate infinite, lc-blob-three 31s infinite; }
.live-casino-blob:nth-child(15) { width: 65px; height: 65px; bottom: -5%; right: 50%; animation: lc-wobble 17s ease-in-out alternate infinite, lc-blob-two 22s infinite; }
.live-casino-blob:nth-child(16) { width: 10px; height: 10px; bottom: -5%; right: 62%; animation: lc-wobble 18s ease-in-out alternate infinite, lc-blob-one 7s infinite; }

.live-casino-blob2 {
  width: 125px;
  height: 125px;
  bottom: 0;
  left: 0;
  position: absolute;
  animation: lc-wobble 8s ease-in-out alternate infinite, lc-move 30s ease-in-out infinite;
  transform-origin: 50% 50%;
}

.live-casino-blob3 {
  width: 93px;
  height: 93px;
  bottom: 0;
  left: 0;
  position: absolute;
  animation: lc-wobble 8s ease-in-out alternate infinite, lc-move2 45s ease-in-out infinite;
  transform-origin: 50% 50%;
}

.live-casino-goo-svg {
  position: absolute;
  width: 0;
  height: 0;
}

.animate-charcter {
  text-transform: uppercase;
  background-image: linear-gradient(90deg, #6c23a9, #f8a0ef, #da9ef6, #a7b0ff, #afd2fd);
  background-size: 200% auto;
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  animation: lc-textclip 3s linear infinite;
  display: inline-block;
}

@keyframes lc-textclip {
  to { background-position: 200% center; }
}

@keyframes lc-wobble {
  50% { border-radius: 42% 58% 70% 30% / 45% 45% 55% 55%; }
  100% { border-radius: 38% 52% 75% 36% / 50% 40% 50% 60%; }
}

@keyframes lc-blob-one {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-700%); }
}

@keyframes lc-blob-two {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-420%); }
}

@keyframes lc-blob-three {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-305%); }
}

@keyframes lc-blob-four {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-605%); }
}

@keyframes lc-blob-five {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-700%); }
}

@keyframes lc-blob-six {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-700%); }
}

@keyframes lc-blob-seven {
  0%, 100% { transform: translateY(0) scale(1); }
  50% { transform: translateY(-300%) scale(0.6); }
}

@keyframes lc-move {
  0% { transform: scale(1) translate(10px, 20px); }
  38% { transform: scale(0.8, 1) translate(40vw, -5vh) rotate(160deg); }
  40% { transform: scale(0.8, 1) translate(40vw, -5vh) rotate(160deg); }
  78% { transform: scale(1.3) translate(0vw, 13vh) rotate(-20deg); }
  80% { transform: scale(1.3) translate(0vw, 13vh) rotate(-20deg); }
  100% { transform: scale(1) translate(10px, 20px); }
}

@keyframes lc-move2 {
  0% { transform: scale(1) translate(80vw, 0); }
  15% { transform: scale(0.8, 1) translate(60vw, 0vh) rotate(180deg); }
  16% { transform: scale(0.8, 1) translate(60vw, 0vh) rotate(180deg); }
  38% { transform: scale(0.8, 1) translate(35vw, 5vh) rotate(120deg); }
  39% { transform: scale(0.8, 1) translate(35vw, 5vh) rotate(120deg); }
  79% { transform: scale(1.3) translate(65vw, 2vh) rotate(-80deg); }
  80% { transform: scale(1.3) translate(65vw, 2vh) rotate(-80deg); }
  100% { transform: scale(1) translate(80vw, 0); }
}

/* Content area */
.live-casino-content {
  padding: 24px 10px 40px;
  position: relative;
}

.live-casino-filters {
  max-width: 1220px;
  margin: 0 auto 20px;
}

.live-casino-filter-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.live-casino-filter-btn {
  background: #6d0cb4;
  border: none;
  border-radius: 30px;
  padding: 10px 12px;
  min-height: 40px;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 13px;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  color: #fff;
  cursor: pointer;
  flex: 1 1 auto;
  min-width: 80px;
  text-align: center;
  transition: background 0.2s, transform 0.2s;
}

.live-casino-filter-btn:hover,
.live-casino-filter-btn.active {
  background: #8a1ad4;
}

.live-casino-filter-btn--liquid {
  position: relative;
  overflow: hidden;
  background: transparent;
  padding: 10px 0;
}

.live-casino-filter-btn--liquid span {
  position: relative;
  z-index: 1;
}

.live-casino-filter-btn--liquid .liquid {
  position: absolute;
  top: -90px;
  left: 0;
  width: 200px;
  height: 200px;
  background: #6d0cb4;
  box-shadow: inset 0 0 50px rgba(0, 0, 0, 0.5);
  transition: 0.5s;
}

.live-casino-filter-btn--liquid .liquid::before,
.live-casino-filter-btn--liquid .liquid::after {
  content: '';
  width: 200%;
  height: 200%;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -75%);
  background: #000;
  opacity: 0.8;
}

.live-casino-filter-btn--liquid .liquid::before {
  border-radius: 45%;
  background: rgba(20, 20, 20, 1);
  animation: lc-animate-liquid 5s linear infinite;
}

.live-casino-filter-btn--liquid .liquid::after {
  border-radius: 40%;
  background: rgba(20, 20, 20, 0.5);
  animation: lc-animate-liquid 10s linear infinite;
}

.live-casino-filter-btn--liquid:hover .liquid {
  top: -120px;
}

@keyframes lc-animate-liquid {
  0% { transform: translate(-50%, -75%) rotate(0deg); }
  100% { transform: translate(-50%, -75%) rotate(360deg); }
}

.live-casino-search {
  position: relative;
  flex: 1 1 220px;
  min-width: 180px;
  height: 40px;
  border-radius: 30px;
  background: #fff;
}

.live-casino-search::before {
  content: '';
  position: absolute;
  inset: -1px;
  background: linear-gradient(to right, #6c23a9, #f8a0ef, #da9ef6, #a7b0ff, #afd2fd);
  border-radius: 30px;
  z-index: 0;
}

.live-casino-search__input {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 38px;
  width: calc(100% - 2px);
  padding: 0 16px 0 40px;
  border-radius: 30px;
  z-index: 1;
  background: #000;
  color: #fff;
  border: none;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.live-casino-search__input:focus {
  outline: none;
}

.live-casino-search__icon {
  position: absolute;
  top: 50%;
  left: 14px;
  transform: translateY(-50%);
  z-index: 2;
  font-size: 14px;
}

/* Category sections */
.live-casino-section {
  max-width: 1220px;
  margin: 0 auto 28px;
}

.live-casino-section__title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 5px 14px;
}

.live-casino-section__title-name {
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 24px;
  letter-spacing: 0.09em;
  color: #fff;
  text-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
}

.live-casino-section__scroll {
  width: 100%;
  overflow-x: auto;
  scrollbar-width: thin;
  scrollbar-color: #6d0cb4 transparent;
  -webkit-overflow-scrolling: touch;
}

.live-casino-section__scroll::-webkit-scrollbar {
  height: 6px;
}

.live-casino-section__scroll::-webkit-scrollbar-thumb {
  background: #6d0cb4;
  border-radius: 3px;
}

.live-casino-section__items {
  display: flex;
  flex-wrap: nowrap;
  gap: 10px;
  padding: 4px 5px 8px;
  width: max-content;
  min-width: 100%;
}

.live-casino-game-card {
  flex: 0 0 163px;
  width: 163px;
  height: 203px;
  border-radius: 15px;
  overflow: hidden;
  cursor: pointer;
  position: relative;
  background: #1a2a2e;
  transition: transform 0.2s;
}

.live-casino-game-card:hover {
  transform: scale(1.03);
}

.live-casino-game-card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.live-casino-game-card__placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94bbe9;
  font-size: 12px;
  text-align: center;
  padding: 8px;
}

.live-casino-loading,
.live-casino-empty {
  text-align: center;
  color: #fff;
  padding: 40px 20px;
  font-size: 16px;
}

.live-casino-loading .lds-hourglass {
  margin: 0 auto 16px;
}

/* Mobile */
@media screen and (max-width: 1024px) {
  .live-casino-blob:nth-child(2),
  .live-casino-blob:nth-child(3),
  .live-casino-blob:nth-child(5),
  .live-casino-blob:nth-child(13),
  .live-casino-blob:nth-child(14) {
    display: none;
  }

  .live-casino-header__text-name {
    font-size: 28px;
    line-height: 36px;
  }

  .live-casino-header__text-credo {
    font-size: 16px;
    line-height: 22px;
    margin-top: 6px;
  }

  .live-casino-section__title-name {
    font-size: 16px;
  }

  .live-casino-filter-btn {
    font-size: 10px;
    min-height: 32px;
    padding: 8px 6px;
    min-width: 60px;
  }

  .live-casino-search {
    flex: 1 1 100%;
    order: 10;
  }

  .live-casino-game-card {
    flex: 0 0 130px;
    width: 130px;
    height: 162px;
  }

  .live-casino-content {
    padding-top: 16px;
    padding-left: 0;
    padding-right: 0;
  }
}

@media screen and (max-width: 480px) {
  .live-casino-filter-row {
    gap: 6px;
  }

  .live-casino-filter-row--primary .live-casino-filter-btn {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 6px);
  }

  .live-casino-game-card {
    flex: 0 0 120px;
    width: 120px;
    height: 150px;
  }
}

/* Mobile-only top spacing – match dark page bg on parents so margin gap isn't white */
@media screen and (max-width: 768px) {
  .desktop-layout-wrapper.casino-full-width:has(.live-casino-page),
  .desktop-main-content.casino-full-width-content:has(.live-casino-page) {
    background-color: #142326 !important;
  }

  .desktop-main-content.casino-full-width-content:has(.live-casino-page) {
    padding: 0 !important;
  }

  .casino-full-width-content:has(.live-casino-page) > div {
    padding: 0 !important;
  }

  .pre-dashboard .casino-full-width-content:has(.live-casino-page),
  .pre-dashboard .desktop-layout-wrapper.casino-full-width:has(.live-casino-page) {
    background-color: #142326 !important;
  }

  .live-casino-page {
    margin-top: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/casino/liveCasino.css"],"names":[],"mappings":"AAAA,4DAA4D;;AAE5D;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;EACX,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,MAAM;EACN,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,gHAAgH;EAChH,kBAAkB;AACpB;;AAEA,iCAAiC,YAAY,EAAE,aAAa,EAAE,OAAO,EAAE,YAAY,EAAE,gFAAgF,EAAE;AACvK,iCAAiC,YAAY,EAAE,aAAa,EAAE,SAAS,EAAE,YAAY,EAAE,gFAAgF,EAAE;AACzK,iCAAiC,YAAY,EAAE,aAAa,EAAE,YAAY,EAAE,QAAQ,EAAE,kFAAkF,EAAE;AAC1K,iCAAiC,YAAY,EAAE,aAAa,EAAE,SAAS,EAAE,OAAO,EAAE,iFAAiF,EAAE;AACrK,iCAAiC,WAAW,EAAE,YAAY,EAAE,YAAY,EAAE,SAAS,EAAE,iFAAiF,EAAE;AACxK,iCAAiC,WAAW,EAAE,YAAY,EAAE,YAAY,EAAE,UAAU,EAAE,iFAAiF,EAAE;AACzK,iCAAiC,WAAW,EAAE,YAAY,EAAE,YAAY,EAAE,UAAU,EAAE,mFAAmF,EAAE;AAC3K,iCAAiC,WAAW,EAAE,YAAY,EAAE,YAAY,EAAE,UAAU,EAAE,iFAAiF,EAAE;AACzK,kCAAkC,WAAW,EAAE,YAAY,EAAE,WAAW,EAAE,UAAU,EAAE,iFAAiF,EAAE;AACzK,kCAAkC,WAAW,EAAE,YAAY,EAAE,WAAW,EAAE,UAAU,EAAE,kFAAkF,EAAE;AAC1K,kCAAkC,WAAW,EAAE,YAAY,EAAE,WAAW,EAAE,UAAU,EAAE,iFAAiF,EAAE;AACzK,kCAAkC,WAAW,EAAE,YAAY,EAAE,YAAY,EAAE,UAAU,EAAE,kFAAkF,EAAE;AAC3K,kCAAkC,WAAW,EAAE,YAAY,EAAE,WAAW,EAAE,UAAU,EAAE,mFAAmF,EAAE;AAC3K,kCAAkC,WAAW,EAAE,YAAY,EAAE,WAAW,EAAE,UAAU,EAAE,iFAAiF,EAAE;AACzK,kCAAkC,WAAW,EAAE,YAAY,EAAE,WAAW,EAAE,UAAU,EAAE,gFAAgF,EAAE;;AAExK;EACE,YAAY;EACZ,aAAa;EACb,SAAS;EACT,OAAO;EACP,kBAAkB;EAClB,wFAAwF;EACxF,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,OAAO;EACP,kBAAkB;EAClB,yFAAyF;EACzF,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,qFAAqF;EACrF,0BAA0B;EAC1B,qBAAqB;EACrB,6BAA6B;EAC7B,kBAAkB;EAClB,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,KAAK,gCAAgC,EAAE;AACzC;;AAEA;EACE,MAAM,gDAAgD,EAAE;EACxD,OAAO,gDAAgD,EAAE;AAC3D;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,4BAA4B,EAAE;AACtC;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,4BAA4B,EAAE;AACtC;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,4BAA4B,EAAE;AACtC;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,4BAA4B,EAAE;AACtC;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,4BAA4B,EAAE;AACtC;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,4BAA4B,EAAE;AACtC;;AAEA;EACE,WAAW,iCAAiC,EAAE;EAC9C,MAAM,uCAAuC,EAAE;AACjD;;AAEA;EACE,KAAK,yCAAyC,EAAE;EAChD,MAAM,6DAA6D,EAAE;EACrE,MAAM,6DAA6D,EAAE;EACrE,MAAM,yDAAyD,EAAE;EACjE,MAAM,yDAAyD,EAAE;EACjE,OAAO,yCAAyC,EAAE;AACpD;;AAEA;EACE,KAAK,sCAAsC,EAAE;EAC7C,MAAM,4DAA4D,EAAE;EACpE,MAAM,4DAA4D,EAAE;EACpE,MAAM,4DAA4D,EAAE;EACpE,MAAM,4DAA4D,EAAE;EACpE,MAAM,yDAAyD,EAAE;EACjE,MAAM,yDAAyD,EAAE;EACjE,OAAO,sCAAsC,EAAE;AACjD;;AAEA,iBAAiB;AACjB;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,gDAAgD;AAClD;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,KAAK,6CAA6C,EAAE;EACpD,OAAO,+CAA+C,EAAE;AAC1D;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,kFAAkF;EAClF,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,2BAA2B;EAC3B,UAAU;EACV,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE;;;;;IAKE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,SAAS;EACX;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,QAAQ;EACV;;EAEA;IACE,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,aAAa;EACf;AACF;;AAEA,sFAAsF;AACtF;EACE;;IAEE,oCAAoC;EACtC;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;;IAEE,oCAAoC;EACtC;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* Live Casino lobby – header animations and category rows */\r\n\r\n.live-casino-page {\r\n  background: #142326;\r\n  min-height: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.live-casino-header {\r\n  position: relative;\r\n  width: 100%;\r\n  overflow: hidden;\r\n  border-radius: 8px;\r\n}\r\n\r\n.live-casino-header__img {\r\n  width: 100%;\r\n  display: block;\r\n  min-height: 180px;\r\n  object-fit: cover;\r\n}\r\n\r\n.live-casino-header__text {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  z-index: 2;\r\n  text-align: center;\r\n  width: 90%;\r\n  pointer-events: none;\r\n}\r\n\r\n.live-casino-header__text-name {\r\n  font-family: 'Lato', sans-serif;\r\n  font-weight: 400;\r\n  font-size: 45px;\r\n  line-height: 54px;\r\n  letter-spacing: 0.09em;\r\n  color: #fff;\r\n  text-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);\r\n  text-transform: uppercase;\r\n}\r\n\r\n.live-casino-header__text-credo {\r\n  font-family: 'Lato', sans-serif;\r\n  font-weight: 400;\r\n  font-size: 26px;\r\n  line-height: 34px;\r\n  letter-spacing: 0.09em;\r\n  color: #fff;\r\n  margin-top: 10px;\r\n  text-align: center;\r\n}\r\n\r\n.live-casino-lamp {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  height: 37vh;\r\n  min-height: 160px;\r\n  width: 100%;\r\n  z-index: 0;\r\n}\r\n\r\n.live-casino-lava {\r\n  filter: url('#goo');\r\n  position: absolute;\r\n  height: 100%;\r\n  width: 100%;\r\n  top: 0;\r\n  left: 0;\r\n}\r\n\r\n.live-casino-blob {\r\n  border-radius: 50%;\r\n  background: linear-gradient(90deg, #eeaeca 0%, #d99cce 10%, #de86e9 24%, #c996e9 47%, #a5aee9 68%, #94bbe9 100%);\r\n  position: absolute;\r\n}\r\n\r\n.live-casino-blob:nth-child(2) { width: 200px; height: 200px; left: 0; bottom: -15%; animation: lc-wobble 4s ease-in-out alternate infinite, lc-blob-one 28s infinite; }\r\n.live-casino-blob:nth-child(3) { width: 330px; height: 330px; right: 5%; bottom: -65%; animation: lc-wobble 5s ease-in-out alternate infinite, lc-blob-two 22s infinite; }\r\n.live-casino-blob:nth-child(4) { width: 150px; height: 150px; bottom: -15%; left: 5%; animation: lc-wobble 6s ease-in-out alternate infinite, lc-blob-three 33s infinite; }\r\n.live-casino-blob:nth-child(5) { width: 125px; height: 125px; bottom: 0; left: 0; animation: lc-wobble 8s ease-in-out alternate infinite, lc-blob-five 18s infinite; }\r\n.live-casino-blob:nth-child(6) { width: 55px; height: 55px; bottom: -25%; left: 17%; animation: lc-wobble 9s ease-in-out alternate infinite, lc-blob-five 32s infinite; }\r\n.live-casino-blob:nth-child(7) { width: 35px; height: 35px; bottom: -25%; right: 20%; animation: lc-wobble 10s ease-in-out alternate infinite, lc-blob-six 12s infinite; }\r\n.live-casino-blob:nth-child(8) { width: 85px; height: 85px; bottom: -35%; right: 22%; animation: lc-wobble 11s ease-in-out alternate infinite, lc-blob-seven 32s infinite; }\r\n.live-casino-blob:nth-child(9) { width: 11px; height: 11px; bottom: -15%; right: 35%; animation: lc-wobble 11s ease-in-out alternate infinite, lc-blob-one 32s infinite; }\r\n.live-casino-blob:nth-child(10) { width: 48px; height: 48px; bottom: -5%; right: 26%; animation: lc-wobble 12s ease-in-out alternate infinite, lc-blob-one 22s infinite; }\r\n.live-casino-blob:nth-child(11) { width: 22px; height: 22px; bottom: -5%; right: 76%; animation: lc-wobble 13s ease-in-out alternate infinite, lc-blob-four 36s infinite; }\r\n.live-casino-blob:nth-child(12) { width: 72px; height: 72px; bottom: -5%; right: 50%; animation: lc-wobble 14s ease-in-out alternate infinite, lc-blob-six 20s infinite; }\r\n.live-casino-blob:nth-child(13) { width: 89px; height: 89px; bottom: -12%; right: 40%; animation: lc-wobble 15s ease-in-out alternate infinite, lc-blob-five 30s infinite; }\r\n.live-casino-blob:nth-child(14) { width: 92px; height: 92px; bottom: -5%; right: 56%; animation: lc-wobble 16s ease-in-out alternate infinite, lc-blob-three 31s infinite; }\r\n.live-casino-blob:nth-child(15) { width: 65px; height: 65px; bottom: -5%; right: 50%; animation: lc-wobble 17s ease-in-out alternate infinite, lc-blob-two 22s infinite; }\r\n.live-casino-blob:nth-child(16) { width: 10px; height: 10px; bottom: -5%; right: 62%; animation: lc-wobble 18s ease-in-out alternate infinite, lc-blob-one 7s infinite; }\r\n\r\n.live-casino-blob2 {\r\n  width: 125px;\r\n  height: 125px;\r\n  bottom: 0;\r\n  left: 0;\r\n  position: absolute;\r\n  animation: lc-wobble 8s ease-in-out alternate infinite, lc-move 30s ease-in-out infinite;\r\n  transform-origin: 50% 50%;\r\n}\r\n\r\n.live-casino-blob3 {\r\n  width: 93px;\r\n  height: 93px;\r\n  bottom: 0;\r\n  left: 0;\r\n  position: absolute;\r\n  animation: lc-wobble 8s ease-in-out alternate infinite, lc-move2 45s ease-in-out infinite;\r\n  transform-origin: 50% 50%;\r\n}\r\n\r\n.live-casino-goo-svg {\r\n  position: absolute;\r\n  width: 0;\r\n  height: 0;\r\n}\r\n\r\n.animate-charcter {\r\n  text-transform: uppercase;\r\n  background-image: linear-gradient(90deg, #6c23a9, #f8a0ef, #da9ef6, #a7b0ff, #afd2fd);\r\n  background-size: 200% auto;\r\n  background-clip: text;\r\n  -webkit-background-clip: text;\r\n  color: transparent;\r\n  animation: lc-textclip 3s linear infinite;\r\n  display: inline-block;\r\n}\r\n\r\n@keyframes lc-textclip {\r\n  to { background-position: 200% center; }\r\n}\r\n\r\n@keyframes lc-wobble {\r\n  50% { border-radius: 42% 58% 70% 30% / 45% 45% 55% 55%; }\r\n  100% { border-radius: 38% 52% 75% 36% / 50% 40% 50% 60%; }\r\n}\r\n\r\n@keyframes lc-blob-one {\r\n  0%, 100% { transform: translateY(0); }\r\n  50% { transform: translateY(-700%); }\r\n}\r\n\r\n@keyframes lc-blob-two {\r\n  0%, 100% { transform: translateY(0); }\r\n  50% { transform: translateY(-420%); }\r\n}\r\n\r\n@keyframes lc-blob-three {\r\n  0%, 100% { transform: translateY(0); }\r\n  50% { transform: translateY(-305%); }\r\n}\r\n\r\n@keyframes lc-blob-four {\r\n  0%, 100% { transform: translateY(0); }\r\n  50% { transform: translateY(-605%); }\r\n}\r\n\r\n@keyframes lc-blob-five {\r\n  0%, 100% { transform: translateY(0); }\r\n  50% { transform: translateY(-700%); }\r\n}\r\n\r\n@keyframes lc-blob-six {\r\n  0%, 100% { transform: translateY(0); }\r\n  50% { transform: translateY(-700%); }\r\n}\r\n\r\n@keyframes lc-blob-seven {\r\n  0%, 100% { transform: translateY(0) scale(1); }\r\n  50% { transform: translateY(-300%) scale(0.6); }\r\n}\r\n\r\n@keyframes lc-move {\r\n  0% { transform: scale(1) translate(10px, 20px); }\r\n  38% { transform: scale(0.8, 1) translate(40vw, -5vh) rotate(160deg); }\r\n  40% { transform: scale(0.8, 1) translate(40vw, -5vh) rotate(160deg); }\r\n  78% { transform: scale(1.3) translate(0vw, 13vh) rotate(-20deg); }\r\n  80% { transform: scale(1.3) translate(0vw, 13vh) rotate(-20deg); }\r\n  100% { transform: scale(1) translate(10px, 20px); }\r\n}\r\n\r\n@keyframes lc-move2 {\r\n  0% { transform: scale(1) translate(80vw, 0); }\r\n  15% { transform: scale(0.8, 1) translate(60vw, 0vh) rotate(180deg); }\r\n  16% { transform: scale(0.8, 1) translate(60vw, 0vh) rotate(180deg); }\r\n  38% { transform: scale(0.8, 1) translate(35vw, 5vh) rotate(120deg); }\r\n  39% { transform: scale(0.8, 1) translate(35vw, 5vh) rotate(120deg); }\r\n  79% { transform: scale(1.3) translate(65vw, 2vh) rotate(-80deg); }\r\n  80% { transform: scale(1.3) translate(65vw, 2vh) rotate(-80deg); }\r\n  100% { transform: scale(1) translate(80vw, 0); }\r\n}\r\n\r\n/* Content area */\r\n.live-casino-content {\r\n  padding: 24px 10px 40px;\r\n  position: relative;\r\n}\r\n\r\n.live-casino-filters {\r\n  max-width: 1220px;\r\n  margin: 0 auto 20px;\r\n}\r\n\r\n.live-casino-filter-row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin-bottom: 16px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.live-casino-filter-btn {\r\n  background: #6d0cb4;\r\n  border: none;\r\n  border-radius: 30px;\r\n  padding: 10px 12px;\r\n  min-height: 40px;\r\n  font-family: 'Lato', sans-serif;\r\n  font-weight: 700;\r\n  font-size: 13px;\r\n  letter-spacing: 0.09em;\r\n  text-transform: uppercase;\r\n  color: #fff;\r\n  cursor: pointer;\r\n  flex: 1 1 auto;\r\n  min-width: 80px;\r\n  text-align: center;\r\n  transition: background 0.2s, transform 0.2s;\r\n}\r\n\r\n.live-casino-filter-btn:hover,\r\n.live-casino-filter-btn.active {\r\n  background: #8a1ad4;\r\n}\r\n\r\n.live-casino-filter-btn--liquid {\r\n  position: relative;\r\n  overflow: hidden;\r\n  background: transparent;\r\n  padding: 10px 0;\r\n}\r\n\r\n.live-casino-filter-btn--liquid span {\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n.live-casino-filter-btn--liquid .liquid {\r\n  position: absolute;\r\n  top: -90px;\r\n  left: 0;\r\n  width: 200px;\r\n  height: 200px;\r\n  background: #6d0cb4;\r\n  box-shadow: inset 0 0 50px rgba(0, 0, 0, 0.5);\r\n  transition: 0.5s;\r\n}\r\n\r\n.live-casino-filter-btn--liquid .liquid::before,\r\n.live-casino-filter-btn--liquid .liquid::after {\r\n  content: '';\r\n  width: 200%;\r\n  height: 200%;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 50%;\r\n  transform: translate(-50%, -75%);\r\n  background: #000;\r\n  opacity: 0.8;\r\n}\r\n\r\n.live-casino-filter-btn--liquid .liquid::before {\r\n  border-radius: 45%;\r\n  background: rgba(20, 20, 20, 1);\r\n  animation: lc-animate-liquid 5s linear infinite;\r\n}\r\n\r\n.live-casino-filter-btn--liquid .liquid::after {\r\n  border-radius: 40%;\r\n  background: rgba(20, 20, 20, 0.5);\r\n  animation: lc-animate-liquid 10s linear infinite;\r\n}\r\n\r\n.live-casino-filter-btn--liquid:hover .liquid {\r\n  top: -120px;\r\n}\r\n\r\n@keyframes lc-animate-liquid {\r\n  0% { transform: translate(-50%, -75%) rotate(0deg); }\r\n  100% { transform: translate(-50%, -75%) rotate(360deg); }\r\n}\r\n\r\n.live-casino-search {\r\n  position: relative;\r\n  flex: 1 1 220px;\r\n  min-width: 180px;\r\n  height: 40px;\r\n  border-radius: 30px;\r\n  background: #fff;\r\n}\r\n\r\n.live-casino-search::before {\r\n  content: '';\r\n  position: absolute;\r\n  inset: -1px;\r\n  background: linear-gradient(to right, #6c23a9, #f8a0ef, #da9ef6, #a7b0ff, #afd2fd);\r\n  border-radius: 30px;\r\n  z-index: 0;\r\n}\r\n\r\n.live-casino-search__input {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  height: 38px;\r\n  width: calc(100% - 2px);\r\n  padding: 0 16px 0 40px;\r\n  border-radius: 30px;\r\n  z-index: 1;\r\n  background: #000;\r\n  color: #fff;\r\n  border: none;\r\n  font-size: 13px;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n}\r\n\r\n.live-casino-search__input:focus {\r\n  outline: none;\r\n}\r\n\r\n.live-casino-search__icon {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 14px;\r\n  transform: translateY(-50%);\r\n  z-index: 2;\r\n  font-size: 14px;\r\n}\r\n\r\n/* Category sections */\r\n.live-casino-section {\r\n  max-width: 1220px;\r\n  margin: 0 auto 28px;\r\n}\r\n\r\n.live-casino-section__title {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin: 0 5px 14px;\r\n}\r\n\r\n.live-casino-section__title-name {\r\n  font-family: 'Lato', sans-serif;\r\n  font-weight: 700;\r\n  font-size: 24px;\r\n  letter-spacing: 0.09em;\r\n  color: #fff;\r\n  text-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);\r\n}\r\n\r\n.live-casino-section__scroll {\r\n  width: 100%;\r\n  overflow-x: auto;\r\n  scrollbar-width: thin;\r\n  scrollbar-color: #6d0cb4 transparent;\r\n  -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n.live-casino-section__scroll::-webkit-scrollbar {\r\n  height: 6px;\r\n}\r\n\r\n.live-casino-section__scroll::-webkit-scrollbar-thumb {\r\n  background: #6d0cb4;\r\n  border-radius: 3px;\r\n}\r\n\r\n.live-casino-section__items {\r\n  display: flex;\r\n  flex-wrap: nowrap;\r\n  gap: 10px;\r\n  padding: 4px 5px 8px;\r\n  width: max-content;\r\n  min-width: 100%;\r\n}\r\n\r\n.live-casino-game-card {\r\n  flex: 0 0 163px;\r\n  width: 163px;\r\n  height: 203px;\r\n  border-radius: 15px;\r\n  overflow: hidden;\r\n  cursor: pointer;\r\n  position: relative;\r\n  background: #1a2a2e;\r\n  transition: transform 0.2s;\r\n}\r\n\r\n.live-casino-game-card:hover {\r\n  transform: scale(1.03);\r\n}\r\n\r\n.live-casino-game-card img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  display: block;\r\n}\r\n\r\n.live-casino-game-card__placeholder {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: #94bbe9;\r\n  font-size: 12px;\r\n  text-align: center;\r\n  padding: 8px;\r\n}\r\n\r\n.live-casino-loading,\r\n.live-casino-empty {\r\n  text-align: center;\r\n  color: #fff;\r\n  padding: 40px 20px;\r\n  font-size: 16px;\r\n}\r\n\r\n.live-casino-loading .lds-hourglass {\r\n  margin: 0 auto 16px;\r\n}\r\n\r\n/* Mobile */\r\n@media screen and (max-width: 1024px) {\r\n  .live-casino-blob:nth-child(2),\r\n  .live-casino-blob:nth-child(3),\r\n  .live-casino-blob:nth-child(5),\r\n  .live-casino-blob:nth-child(13),\r\n  .live-casino-blob:nth-child(14) {\r\n    display: none;\r\n  }\r\n\r\n  .live-casino-header__text-name {\r\n    font-size: 28px;\r\n    line-height: 36px;\r\n  }\r\n\r\n  .live-casino-header__text-credo {\r\n    font-size: 16px;\r\n    line-height: 22px;\r\n    margin-top: 6px;\r\n  }\r\n\r\n  .live-casino-section__title-name {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .live-casino-filter-btn {\r\n    font-size: 10px;\r\n    min-height: 32px;\r\n    padding: 8px 6px;\r\n    min-width: 60px;\r\n  }\r\n\r\n  .live-casino-search {\r\n    flex: 1 1 100%;\r\n    order: 10;\r\n  }\r\n\r\n  .live-casino-game-card {\r\n    flex: 0 0 130px;\r\n    width: 130px;\r\n    height: 162px;\r\n  }\r\n\r\n  .live-casino-content {\r\n    padding-top: 16px;\r\n    padding-left: 0;\r\n    padding-right: 0;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 480px) {\r\n  .live-casino-filter-row {\r\n    gap: 6px;\r\n  }\r\n\r\n  .live-casino-filter-row--primary .live-casino-filter-btn {\r\n    flex: 1 1 calc(50% - 6px);\r\n  }\r\n\r\n  .live-casino-game-card {\r\n    flex: 0 0 120px;\r\n    width: 120px;\r\n    height: 150px;\r\n  }\r\n}\r\n\r\n/* Mobile-only top spacing – match dark page bg on parents so margin gap isn't white */\r\n@media screen and (max-width: 768px) {\r\n  .desktop-layout-wrapper.casino-full-width:has(.live-casino-page),\r\n  .desktop-main-content.casino-full-width-content:has(.live-casino-page) {\r\n    background-color: #142326 !important;\r\n  }\r\n\r\n  .desktop-main-content.casino-full-width-content:has(.live-casino-page) {\r\n    padding: 0 !important;\r\n  }\r\n\r\n  .casino-full-width-content:has(.live-casino-page) > div {\r\n    padding: 0 !important;\r\n  }\r\n\r\n  .pre-dashboard .casino-full-width-content:has(.live-casino-page),\r\n  .pre-dashboard .desktop-layout-wrapper.casino-full-width:has(.live-casino-page) {\r\n    background-color: #142326 !important;\r\n  }\r\n\r\n  .live-casino-page {\r\n    margin-top: 16px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
